import React, {useState, Fragment} from 'react';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import DatosDeEmpresa from 'components/nuevoTarifario/DatosDeEmpresa';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import {useDispatch, useSelector} from 'react-redux';
import NuevaVallaMovil from './NuevaVallaMovil';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';
import { nuevoOActualizarRegistroPersonalizado, obtenerRegistrosPorURL } from 'store/actions/customAction';
import ModalDeConfirmacion from 'components/Modales/ModalDeConfirmacion';
import DetalleDeLaVallaFija from '../vallasFijas/DetalleDeLaVallaFija';
import DetalleDeLaVallaMovil from './DetalleDeLaVallaMovil';

const VallasMoviles = () => {
    const dispatch = useDispatch();
    const [tarifarioDeVallasMoviles] = useState('tarifarioDeVallasMoviles');
    const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, });
    const[cargandoSolicitud, setCargandoSolicitud] = useState(false);
    const [abrirNuevaVallaMovil, setAbrirNuevoVallaMovil] = useState(false);
    const [datosDeEmpresa, setDatosDeEmpresa] = useState({});
    const [recargarLaTabla, setRecargarLaTabla] = useState(false),
    [datosGeneralesDelTarifario, setDatosGeneralesDelTarifario] = useState({}),
    [abrirDetalleTarifario, setAbrirDetalleTarifario] = useState(false),
    [alertaDeConfirmacion, setAlertaDeConfirmacion] = useState(false);

    const [header] = useState([
        { title: 'Tipo de móvil', field: 'medioDeComunicacion.nombre', render: rowData => <div> {rowData?.esMovil ? "MÓVIL DIGITAL" : "MÓVIL FÍSICA"} </div>},
        { title: 'costo', field: 'costo'},
        { title: 'Acciones', field: 'accion',
        render: rowData=><div style={{minWidth: '100px'}}>
            {
                (<div>
                    <TooltipPersonalizado title="Visualizar detalle de la valla móvil" handleFunction={() => mostrarDetalleDelMedio(rowData, null)} icon="visibility" fontSize={30} />
                    <TooltipPersonalizado title="Editar valla móvil" handleFunction={() => mostrarDetalleDelMedio(rowData, 'editar')} icon="edit" fontSize={30} />
                    <TooltipPersonalizado title="Eliminar valla móvil" handleFunction={() => mostrarAlertaDeConfirmacion(rowData)} icon="delete" fontSize={30} color="red" />

                </div>)
            }
            </div>
        },
    ]);

    const mostrarAlertaDeConfirmacion = async (elemento) => {
        setDatosGeneralesDelTarifario(elemento)
        setAlertaDeConfirmacion(true)
    }

    const mostrarDetalleDelMedio = async (elemento, tipoConsulta) => {
        setCargandoSolicitud(true);

        let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: tarifarioDeVallasMoviles, saveInStore: false, nombreDelMetodo: "listar/registros", parametro: elemento.medioDeComunicacion?.id}));

        setCargandoSolicitud(false);

        if(respuesta?.error) return alertaPersonalizadaSwal(`${respuesta.error?.message || "No se pudo obtener la información del valla"}`);

        if(respuesta?.data?.length === 0) return alertaPersonalizadaSwal("No existen datos para mostrar");

        setDatosGeneralesDelTarifario(respuesta.data)
        if(tipoConsulta) setAbrirNuevoVallaMovil(true);
        else setAbrirDetalleTarifario(true)
    }

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => setDatosDeRespuesta({tipoDeAlerta,mensajeDeAlerta,mostrarRespuesta,})

    const addRegister= () => {
        setDatosGeneralesDelTarifario({})
        if(!datosDeEmpresa?.ejecutivoDeMedios?.cui) return alertaPersonalizadaSwal("Debe completar los datos Contacto de medios para agregar otra valla móvil", "", "warning")
        setAbrirNuevoVallaMovil(true);
    }

    const datosEditados = (respuesta) => {
        alertaPersonalizadaSwal(respuesta || "Datos editados correctamente", "", "success")
        setAbrirNuevoVallaMovil(false);
        setRecargarLaTabla(true)
    }

    const cerrarNuevaVallaMovil= (recargar = false) => {
        setAbrirNuevoVallaMovil(false)
        setRecargarLaTabla(recargar)
    };

    const cerrarDetalleDelTarifario = () => setAbrirDetalleTarifario(false)

    const accionDeAlertaDeConfirmacion = async () => {
        setAlertaDeConfirmacion(false);
        setCargandoSolicitud(true);
        changeDataResponse('error', "")

        const data = { controller: tarifarioDeVallasMoviles, action: 'deshabilitar', data: {}, nombreDelMetodo: `deshabilitar/${datosGeneralesDelTarifario?.medioDeComunicacion?.id}` };
        const respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(data));
        setCargandoSolicitud(false);
        if(respuesta?.error) return alertaPersonalizadaSwal(respuesta.error?.message || "", "", '');
        alertaPersonalizadaSwal(respuesta?.data || "Registro eliminado correctamente", "", 'success');
        setRecargarLaTabla(true)
    }

    const cerrarAlertaDeConfirmacion = () => setAlertaDeConfirmacion(false);

    const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;

    return (
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>

            <DatosDeEmpresa
                header={header}
                tituloGeneral={"FORMULARIO DE REGISTRO VALLAS MÓVILES"}
                icon={"vallas_moviles"}
                tituloDeTabla={"LISTADO DE VALLAS MÓVILES"}
                addRegister={addRegister}
                nombreToolTip={"AGREGAR VALLA MÓVIL"}
                iconTabla={"vallas_moviles"}
                setDatosDeEmpresa={setDatosDeEmpresa}
                controladorTarifario={"tarifarioDeVallasMoviles"}
                recargarLaTabla={recargarLaTabla}
                datosDeEmpresa={datosDeEmpresa}
                setRecargarLaTabla={setRecargarLaTabla}
                tipoMedio="vallasMoviles"
            />

            {abrirNuevaVallaMovil && (
                <NuevaVallaMovil
                    openFullScreenDialog={abrirNuevaVallaMovil}
                    handleClose={cerrarNuevaVallaMovil}
                    title={"Formulario para agregar nueva valla móvil"}
                    datosDeEmpresa={datosDeEmpresa}
                    datosGeneralesDelTarifario={datosGeneralesDelTarifario}
                    datosEditados={datosEditados}
                />
            )}
            {abrirDetalleTarifario && (
                <DetalleDeLaVallaMovil
                    openFullScreenDialog={abrirDetalleTarifario}
                    handleClose={cerrarDetalleDelTarifario}
                    title={'Detalle del valla móvil'}
                    datosGeneralesDelTarifario={datosGeneralesDelTarifario}
                />
            )}
            {alertaDeConfirmacion && (
                <ModalDeConfirmacion
                    title={`¿Está seguro de eliminar la valla ${datosGeneralesDelTarifario?.medioDeComunicacion?.nombre || ""}?`} message={"No podrá revertir esta acción"}
                    open={alertaDeConfirmacion} closeModal={cerrarAlertaDeConfirmacion} titleButton={"Sí, estoy seguro"}
                    actionAdd={accionDeAlertaDeConfirmacion}
                />
            )}
        </Fragment>
    );
}

export default VallasMoviles;